import React from 'react';
import { Box, Heading, Text, Container, Flex, Button } from '@stockx/ui';

import {
  BrowseSwitcherLink,
  ButtonLink,
  ExternalSwitcherLink,
  useLocation,
} from '@app/router';

import { ArrowRightIcon } from '@stockx/icons';
import { useSelector } from 'react-redux';

import {
  getSalesforceLanguageCode,
  getUrlPrefix,
} from '@app/redux/localization/selectors';

import { useTranslation } from 'react-i18next';

const Wrapper = ({ children }) => (
  <Container position="relative" maxW="100%" minH="100vh">
    <Flex justify="center" overflow="hidden">
      {children}
    </Flex>
  </Container>
);

const TapeLineTop = () => (
  <Box
    position="absolute"
    height="77px"
    backgroundColor="orange.500"
    backgroundImage="url('https://stockx-assets.imgix.net/404/404-v2-OrangeTape.jpg?h=77&auto=compress,format')"
    backgroundPosition="center"
    width="1000px"
    transform="rotate(9.38deg)"
    top="-11px"
    right="-19px"
  />
);

const TapeLineBottomBack = () => (
  <Box
    position="absolute"
    height="60px"
    backgroundColor="pink.300"
    backgroundImage="url('https://stockx-assets.imgix.net/404/404-v2-PinkTape.jpg?h=60&auto=compress,format')"
    backgroundPosition="center"
    width="3000px"
    transform={{ base: 'rotate(-4.49deg)', md: 'rotate(-3.94deg)' }}
    top={{ base: '68%', md: '60%' }}
  />
);

const TapeLineBottomTop = () => (
  <Box
    position="absolute"
    height="77px"
    backgroundColor="green.700"
    backgroundImage="url('https://stockx-assets.imgix.net/404/404-v2-GreenTape.jpg?h=77&auto=compress,format')"
    backgroundPosition="center"
    width="3000px"
    transform="rotate(3.29deg)"
    top={{ base: '76%', md: '60%' }}
  />
);

const Content = () => {
  const helpLanguage = useSelector(getSalesforceLanguageCode);
  const urlPrefix = useSelector(getUrlPrefix);
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <Box p={{ base: 8, md: 4 }} marginTop={{ base: '8em' }}>
      <Box>
        <Heading
          textAlign="center"
          fontSize={{ base: '2xl', md: '3xl' }}
          fontWeight="bold"
        >
          {t('error_not_found_page_primary_text')}
        </Heading>
      </Box>
      <Box>
        <Text textAlign="center" fontSize={{ base: 'md', md: 'lg' }} my="6">
          {t('error_not_found_page_secondary_text')}:
        </Text>
      </Box>
      <Box>
        <Box textAlign="center">
          <ButtonLink
            textAlign="center"
            variant="link"
            size="md"
            color="green.700"
            to={`${urlPrefix}`}
          >
            <Text as="span" textTransform="capitalize" pr={1}>
              {t('homepage')}
            </Text>
            <ArrowRightIcon />
          </ButtonLink>
        </Box>
        <Box textAlign="center">
          <ButtonLink
            as={BrowseSwitcherLink}
            variant="link"
            size="md"
            color="green.700"
            to={`${urlPrefix}sneakers`}
          >
            <Text as="span" pr={1}>
              {t('Browse')}
            </Text>
            <ArrowRightIcon />
          </ButtonLink>
        </Box>
        <Box textAlign="center">
          <ButtonLink
            as={ExternalSwitcherLink}
            variant="link"
            size="md"
            color="green.700"
            to={`https://help.stockx.com/?language=${helpLanguage}`}
          >
            <Text as="span" pr={1}>
              {t('help_center')} <ArrowRightIcon />
            </Text>
          </ButtonLink>
        </Box>

        <Box textAlign="center" marginTop="4">
          <Button variant="primary" size="md" onClick={() => location.reload()}>
            {t('Retry')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

const ErrorNotFoundView = () => (
  <Wrapper>
    <TapeLineTop />
    <Content />
    <TapeLineBottomBack />
    <TapeLineBottomTop />
  </Wrapper>
);

export default ErrorNotFoundView;
